import styled from 'styled-components';

export const NavWrapper = styled.nav`
display: flex;
`;
